import { createSelector } from "reselect";

import { organizationEntityAdapter, organizationSlice } from "./slice";

const selectOrganizationState = (state) => state[organizationSlice.name];

export const selectOrganizationEntities = createSelector(selectOrganizationState, (organizationState) =>
  organizationEntityAdapter.getSelectors().selectEntities(organizationState),
);

export const selectOranizations = createSelector(selectOrganizationState, (organizationState) =>
  organizationEntityAdapter.getSelectors().selectAll(organizationState),
);

export const selectSelectedOrganizationDetails = createSelector(
  selectOrganizationState,
  (state, props) => props.entityId,
  (organizationState, organizationId) =>
    organizationEntityAdapter.getSelectors().selectById(organizationState, organizationId) || null,
);

export const selectSelectedOrganisationAccountId = createSelector(
  selectSelectedOrganizationDetails,
  (organizationDetails) => organizationDetails?.account_id || "",
);

export const selectSelectedOrganisationClientId = createSelector(
  selectSelectedOrganizationDetails,
  (organizationDetails) => organizationDetails?.client_id || "",
);

export const selectSelectedOrganisationClientSecret = createSelector(
  selectSelectedOrganizationDetails,
  (organizationDetails) => organizationDetails?.client_secret || "",
);

export const selectSelectedOrganisationTotalUsers = createSelector(
  selectSelectedOrganizationDetails,
  (organizationDetails) => organizationDetails?.totalUsers || 0,
);

export const selectSelectedOrganisationPlanId = createSelector(
  selectSelectedOrganizationDetails,
  (organizationDetails) => organizationDetails?.planId || {},
);

export const selectSelectedOrganisationName = createSelector(
  selectSelectedOrganizationDetails,
  (organizationDetails) => organizationDetails?.name || "",
);

export const selectFilteredOrganizations = createSelector(
  selectOrganizationState,
  (organizationState) => organizationState.filteredOrganizations || [],
);

export const selectTotalFilteredOrganizations = createSelector(
  selectOrganizationState,
  (organizationState) => organizationState.totalFilteredOrganizations || 0,
);
